export const LIST = 'list';
export const MAP = 'map';

export const SHOW_OPTIONS = {
  [MAP]: 'Map',
  [LIST]: 'List'
};
